import { CustomTypedEvent } from '@pacem/pacem-core';
export const FieldChangeEventName = 'change';
export class FieldChangeEvent extends CustomTypedEvent {
    constructor(args) {
        super(FieldChangeEventName, args, { bubbles: true, cancelable: false });
    }
}
//}
